import { AbstractPaymentMethodService } from '~/components/ClientExperience/services/abstract-payment-method.service';

export class LegacyPayService extends AbstractPaymentMethodService {
    protected createChargeableBankAccountUrl = ({ userId }): string =>
        `/api/v2/users/${userId}/chargeable_bank_account`;

    protected createLinkTokenUrl = ({ userId }): string =>
        `/api/v2/users/${userId}/plaid/create_link_token`;

    protected createPaymentMethodUrl = ({ userId }): string =>
        `/api/v2/users/${userId}/payment_methods`;

    protected exchangePublicTokenUrl = ({ userId }): string =>
        `/api/v2/users/${userId}/plaid/exchange_public_token`;

    protected plaidEventUrl = ({ userId }): string =>
        `/api/v2/users/${userId}/plaid/event`;
}
